<template>
    <v-dialog
        v-model="innerValue"
        max-width="500"
        content-class="rounded-xl"
    >
        <v-card
            rounded="xl"
            light
        >
            <v-card-title class="d-flex justify-space-between">
                <v-btn
                    class="ml-auto"
                    icon
                    @click="innerValue = false"
                >
                    <v-icon color="primary">
                        mdi-close
                    </v-icon>
                </v-btn>
            </v-card-title>

            <v-carousel
                v-model="slide"
                :continuous="false"
                :show-arrows="false"
                hide-delimiter-background
                delimiter-icon="mdi-minus"
                height="300"
                light
            >
                <v-carousel-item
                    v-for="(slide, i) in slides"
                    :key="i"
                >
                    <v-sheet
                        class="mx-16"
                        height="100%"
                    >
                        <v-row
                            class="fill-height"
                            align="center"
                            justify="center"
                        >
                            <p>
                                {{ slide }}
                            </p>
                        </v-row>
                    </v-sheet>
                </v-carousel-item>
            </v-carousel>

            <v-card-actions>
                <v-btn
                    v-if="slide !== 0"
                    color="primary"
                    depressed
                    text
                    @click="slide--"
                >
                    Prev
                </v-btn>
                <v-spacer />
                <v-btn
                    v-if="slide !== slides.length - 1"
                    color="primary"
                    depressed
                    text
                    @click="slide++"
                >
                    Next
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        props: {
            value: {
                type: Boolean,
                required: true,
            },
            matcherPaymentProvider: {
                type: Object,
                required: false,
                default: () => ({}),
            },
        },
        data: () => ({
            innerValue: null,
            slide: 0,
        }),
        computed: {
            slides() {
                const { company } = this.matcherPaymentProvider || {};
                if (!company) {
                    return [];
                }

                const companyName = company.name;
                return [
                    `Below is the temporary virtual USD bank account and
                    recipient details to make payment to on ${companyName}.
                    DO NOT RE-USE a saved temporary virtual account details.`,
                    `After your USD payment to the temporary virtual account is confirmed,
                    your recipient in Nigeria will receive NAIRA in the naira account you
                    added to this transaction.`,
                    `Please note that only complete payments will be accepted.
                    Partial and incomplete payments would not be acknowledged as
                    received and are unacceptable!`,
                ];
            },
        },
        watch: {
            value: {
                immediate: true,
                handler(val) {
                    this.innerValue = val;
                },
            },
            innerValue(val) {
                this.$emit('input', val);
            },
        },
    };
</script>
